<template>
  <generic-historical 
    :get-detalle="getDetalleAux"
    :get-pag="getPagAux"
    :get-excel="getExcelAux"
    :get-params="getParamsAux"
    :get-params-detalle="getParamsDetalleAux"
    :excel-name="ExcelName"
    :id-vista="idVista"
    :header-url="headerUrl"
    :detail-response-path="detailResponsePath"
    :breadcrumbs="breadcrumbs"
    :vuexnamespace="vuexnamespace" />
</template>

<script>
import _ from 'lodash'
import { i18n } from '@/i18n'
import GenericHistorical from '@/views/historical/GenericHistorical.vue'
import { getCertificate } from '@/services/certificates/getCertificate'
import { getHistoricalByCertificate } from '@/services/historical/getHistoricalByCertificate'
import { getHistoricalByCertificateExcel } from '@/services/historical/getHistoricalByCertificateExcel'

export default {
  name: 'list-trash-certificate-historical',
  components: {
    GenericHistorical
  },
  data: function () {
    return {
      idVista: 30,
      vuexnamespace: 'trashHistoricalCertificates',
      headerUrl: 'trash/certificates/details',
      detailResponsePath: 'Certificado',
      breadcrumbs: [
        { url: 'trash/certificates', name: i18n.t('trash.header') },
        { url: 'trash/certificates', name: i18n.t('trash.certificates') },
        { paths: ['CommonName'] },
      ],
      ExcelName: `${_.kebabCase(i18n.t('certificates.entity_name') + i18n.t('historical.entity_name'))}.xlsx`,
    }
  },
  methods: {
    getParamsAux: function (data) {
      return {
        serialNumber: this.$route.params.SerialNumber,
        idEmpresa: this.$route.params.idCliente,
        tipoCertificado: this.$route.params.TipoCertificado,
      }
    },
    getParamsDetalleAux: function (data) {
      return {
        serial: this.$route.params.SerialNumber,
        idCliente: this.$route.params.idCliente,
        tipoCertificado: this.$route.params.TipoCertificado,
        borrado: true,
      }
    },
    getDetalleAux: async function (params) {
      return await getCertificate(params)
    },
    getExcelAux: async function (payload, params) {
      return await getHistoricalByCertificateExcel(payload, params)
    },
    getPagAux: async function (payload, params) {
      return await getHistoricalByCertificate(payload, params)
    },
  }
}
</script>

<style lang="scss" scoped></style>
